import CsvContentParserFactory from 'services/csv/content-parser/factory';
import PlayersSnippetValidatorFactory from './services/snippet-validators/players-snippet-validator-factory';
import AttributesMapFactory, {attributeStructure} from 'components/organisms/players-csv/attributes-map-factory';
import {isNumeric, toFloat} from 'helpers/number-helper';

export function parseContentByCells(content: string, sportConfig): string[][] {
    const fileParser = CsvContentParserFactory.getParser(sportConfig);

    return fileParser.parse(content);
}

export function assertPlayersSnippetFormatIsValid(playersSnippet: any[], sportConfig): void {
    const validator = PlayersSnippetValidatorFactory.getValidator(sportConfig);

    validator.assertSnippetIsValid(playersSnippet);
}

export function mapPlayersSnippet(playersSnippet: any[], sportConfig): object[] {
    const attributes: attributeStructure[] = AttributesMapFactory.fromSportConfig(sportConfig);

    const attributesDictionary: object = {};
    attributes.map((attribute) => (attributesDictionary[attribute.headAttributeName] = attribute.playerPropName));

    const [headAttributeNames, ...valuesSnippet] = playersSnippet;

    return valuesSnippet.map((row) => {
        const player: object = {};
        headAttributeNames
            .filter((attributeName) => attributeName in attributesDictionary)
            .map((attributeName, index) => {
                player[attributesDictionary[attributeName]] = row[index];
            });

        return player;
    });
}

export function normalizeCsvPlayers(csvPlayers: object[]): object[] {
    const filteredCsvPlayers = csvPlayers.filter((item: any) => item.name);

    return filteredCsvPlayers.map((item: any) => {
        if (isNumeric(item.userPoints)) {
            item.userPoints = toFloat(item.userPoints, 3);
        } else {
            item.userPoints = '-';
        }

        return item;
    });
}
